import { createSlice } from '@reduxjs/toolkit';

export const locationSlice = createSlice({
  name: 'location',
  initialState: {
    currentDevice: null,
  },
  reducers: {
    setCurrentDevice: (state, action) => {
      state.currentDevice = action.payload;
    },
  },
});

export const { setCurrentDevice } = locationSlice.actions;

export const selectCurrentDevice = (state) => state.location.currentDevice;

export default locationSlice.reducer;
